import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useT } from '../../../../../../_metronic/i18n/Metronici18n'
import { TableCard } from '../../../../../components/Table/TableCard'
import { CriarRascunhoButton } from '../../acoes/CriarRascunhoButton'
import { CLASSE_LINK_OUTLINE } from '../../core/classeLinkOutline'
import { useVersoesProtocolo } from '../core/useVersoesProtocolo'

/** Card do modelo Lauduz abaixo da tabela: ver o modelo ou criar um rascunho a partir dele. */
export const ModeloLauduzCard: FC = () => {
  const { t } = useT()
  const { modelo, idEmpresa, acoes } = useVersoesProtocolo()

  if (!acoes.podeCriarRascunho || !modelo) return null

  return (
    <TableCard className='mt-6'>
      <div className='card-body d-flex flex-wrap justify-content-between align-items-center gap-4'>
        <div>
          <h3 className='fs-5 fw-bold mb-1'>
            {t('protocolos_triagem.modelo.titulo', undefined, 'Modelo Lauduz')}
          </h3>
          <p className='mb-0 text-gray-700'>
            {t(
              'protocolos_triagem.modelo.formato',
              { versao: modelo.versao },
              `Versão ${modelo.versao} do modelo`
            )}{' '}
            · hash {modelo.hash?.slice(0, 12)}
          </p>
        </div>
        <div className='d-flex flex-wrap align-items-center gap-3'>
          <Link className={CLASSE_LINK_OUTLINE} to='/apps/protocolos-triagem/modelo'>
            Visualizar modelo
          </Link>
          <CriarRascunhoButton
            escopo='modelo'
            idEmpresa={idEmpresa}
            versaoModelo={modelo.versao}
            podeCriarRascunho={acoes.podeCriarRascunho}
            rotulo='Criar rascunho a partir do modelo'
            aparencia='principal'
          />
        </div>
      </div>
    </TableCard>
  )
}
